import React, { useEffect } from 'react';
import OnlineReviewComp from './components/OnlineReviewComp';
import { View } from '../../components/Common/react-native-components';
import { useDispatch } from 'react-redux';
import { clearOnlineReviewData } from './actions/fetchOnlineReviewData';

const OnlineReview = () => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   return () => dispatch(clearOnlineReviewData());
  // }, []);

  return (
    <View style={{ marginTop: 20 }}>
      <OnlineReviewComp />
    </View>
  );
};
export default OnlineReview;
